module.exports = __webpack_public_path__ + "static/img/pexels-pixabay-267350@2x.cd760a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productServices/productOperation/innovativeTechnology/pexels-pixabay-267350@2x.png
// module id = IFM2
// module chunks = 0